/**
 * Creates a wrapper for the blog posts with Shoptet classes.
 * @returns {HTMLElement} Wrapper for the blog posts
 */
const createBlogPostsWrapper = () => {
	const blogPostsWrapper = document.createElement('div')
	blogPostsWrapper.id = 'newsWrapper'
	blogPostsWrapper.classList.add('news-wrapper')
	return blogPostsWrapper
}

/**
 * !! DEFAULT SHOPTET FUNCTION SHOULD BE USED INSTEAD !!
 * Fetches blog posts from the specified URL and returns them as a wrapper.
 * If the blog posts are already fetched, it returns them from the session storage.
 * Returns a promise, should be used with async/await.
 * @async Fetch blog
 * @param {string} url - URL of the blog page
 * @param {number} numberOfPosts - Number of posts to fetch
 * @returns {HTMLElement} Wrapper with fetched blog posts
 */
const fetchBlogPosts = async (url, numberOfPosts) => {
	const cookieName = url.replaceAll('/', '_') + 'posts'
	return new Promise(async (resolve, reject) => {
		if (window.sessionStorage.getItem(cookieName)) {
			const blogPostsWrapper = createBlogPostsWrapper()
			blogPostsWrapper.innerHTML = window.sessionStorage.getItem(cookieName)
			resolve(blogPostsWrapper)
			return
		}
		try {
			const BlogURL = url || '/blog/'
			const response = await fetch(BlogURL)
			const data = await response.text()
			const parser = new DOMParser()
			const htmlDocument = parser.parseFromString(data, 'text/html')
			const blogPosts = htmlDocument.querySelectorAll('.news-item')
			if (blogPosts.length === 0) return null
			const blogImage = blogPosts[0].querySelector('.image img')
			if (blogImage) {
				const blogImageSrc = blogImage.getAttribute('data-src')
				if (blogImageSrc) blogImage.src = blogImageSrc
			}

			const blogPostsWrapper = createBlogPostsWrapper()
			for (let i = 0; i < numberOfPosts; i++) {
				if (blogPosts[i]) blogPostsWrapper.appendChild(blogPosts[i])
			}
			window.sessionStorage.setItem(cookieName, blogPostsWrapper.innerHTML)
			resolve(blogPostsWrapper)
		} catch (error) {
			console.error('Error fetching blog posts:', error)
			reject(error)
		}
	})
}

/**
 * Fetches HTML from the specified URL and returns it as a document.
 * Return the element with the specified selector if provided.
 * Returns a promise, should be used with async/await.
 * @async Fetch HTML
 * @param {string} url - URL of the page to fetch
 * @param {string} selector - Selector of the element to return
 * @returns {HTMLDocument|HTMLElement|null} HTML document or element with the specified selector
 */
const fetchHTMLfromURL = async (url, selector = false) => {
	const cookieName = url.replaceAll('/', '_') + selector
	return new Promise(async (resolve, reject) => {
		if (window.sessionStorage.getItem(cookieName)) {
			if (selector) {
				const element = document.createElement('div')
				element.innerHTML = window.sessionStorage.getItem(cookieName)
				resolve(element.querySelector(selector))
				return
			}
			const htmlDocument = document.createElement('html')
			htmlDocument.innerHTML = window.sessionStorage.getItem(cookieName)
			resolve(htmlDocument)
			return
		}
		try {
			const response = await fetch(url)
			const data = await response.text()
			const parser = new DOMParser()
			const htmlDocument = parser.parseFromString(data, 'text/html')

			if (selector) {
				window.sessionStorage.setItem(cookieName, htmlDocument.querySelector(selector).outerHTML)
				return htmlDocument.querySelector(selector)
			}
			window.sessionStorage.setItem(cookieName, htmlDocument.documentElement.outerHTML)

			return htmlDocument
		} catch (error) {
			console.error(`Error fetching HTML (URL: ${url}):`, error)
			return null
		}
	})
}

export { fetchBlogPosts, fetchHTMLfromURL }
